import { useMemo } from "react"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/layer/authoring/layer.authoring.status.query.gql"
import { IS_CATALOG_AUTHORING_ENABLED } from "@/v2-backoffice-client/feature/feature.constants"
import type { LayerAuthoringStatusesQuery } from "@/v2-backoffice-client/layer/authoring/__types__/layer.authoring.status.query"

export type LayerAuthoringStatus =
  LayerAuthoringStatusesQuery["getLayerAuthoringStatuses"][number]

/**
 * Catalog → production sync state for every layer. Self-gated: never
 * queried on deployments without the authoring catalog (prod), where every
 * consumer hides its authoring UI anyway.
 */
export function useLayerAuthoringStatusesQuery() {
  return useQuery<LayerAuthoringStatusesQuery>(query, {
    skip: !IS_CATALOG_AUTHORING_ENABLED,
  })
}

/** The same statuses keyed by FeatureCode, for per-row chip lookups. */
export function useLayerAuthoringStatusMap() {
  const { data } = useLayerAuthoringStatusesQuery()
  return useMemo(() => {
    const map = new Map<string, LayerAuthoringStatus>()
    for (const status of data?.getLayerAuthoringStatuses ?? []) {
      map.set(status.FeatureCode, status)
    }
    return map
  }, [data])
}
